import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CreateJobFileRequest, JobFile, HttpResponse } from "@/types";

export function useCreateJobFile() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      createJobFileRequest,
    }: {
      createJobFileRequest: CreateJobFileRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/files`;
      const res = await guacHttpClient.postForm<
        JobFile,
        HttpResponse<JobFile>,
        CreateJobFileRequest
      >(path, createJobFileRequest);

      return res.data;
    },
  });

  return mutation;
}
